import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CompanyOfferService,
  CompanyOfferV2Model,
  PopulationQuery,
} from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

interface OfferCategoryGroup {
  categoryId: number;
  categoryName: string;
  ordinal: number;
  offers: CompanyOfferV2Model[];
}
@Component({
  selector: 'fgb-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss'],
})
export class BrandListComponent implements OnInit {
  offerCategories$: Observable<OfferCategoryGroup[]>;
  isClub1901: boolean;

  constructor(
    private companyOfferService: CompanyOfferService,
    private populationQuery: PopulationQuery,
  ) { }

  ngOnInit(): void {
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
    this.offerCategories$ = this.companyOfferService.fetchOffersV2(0, 0).pipe(
      map((offers) => this.groupOffersByCategory(offers))
    );
  }

  private groupOffersByCategory(
    offers: CompanyOfferV2Model[]
  ): OfferCategoryGroup[] {
    const categoryMap = new Map<number, OfferCategoryGroup>();

    offers.forEach((offer) => {
      offer.CategoryTags?.forEach((category) => {
        if (!category.CategoryName) {
          return;
        }

        if (!categoryMap.has(category.CategoryTagId)) {
          categoryMap.set(category.CategoryTagId, {
            categoryId: category.CategoryTagId,
            categoryName: category.CategoryName,
            ordinal: category.Ordinal,
            offers: [],
          });
        }

        categoryMap.get(category.CategoryTagId)!.offers.push(offer);
      });
    });

    return Array.from(categoryMap.values()).sort(
      (a, b) => a.ordinal - b.ordinal
    );
  }
}
